import { type App } from 'vue'
import autogrow from './textarea-autogrow'

export default {
  install (app: App) {
    app.directive('autogrow', autogrow)
  },
}
